var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaSignetDarkBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "84px",
    height: "84px",
    viewBox: "0 0 84 84",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CI / Logo / Signet / CA-Signet-Dark-Background") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CI-/-Logo-/-Signet-/-CA-Signet-Dark-Background",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.5204353,26.2223821 L69.0547094,57.7776179 L65.9955301,57.7776179 L50.461256,26.2223821 L53.5204353,26.2223821 Z M53.5651311,43.7927983 L54.9134545,46.5391069 L49.5996203,46.5391069 C47.4169753,46.5391069 45.423046,47.7781739 44.4596031,49.7373398 C43.3248264,51.7436847 41.7306761,53.511652 39.8484863,54.8550091 C37.2809608,56.6838663 34.2817796,57.6880338 31.1486567,57.7718956 L30.7206104,57.7776179 L30.1817777,57.7577531 L30.1817777,55.1331163 L30.5815568,55.1380825 C32.7046074,55.1579473 34.8102762,54.6687766 36.6676351,53.7202324 C39.0563774,52.4985471 41.0801039,50.3903952 42.3638667,47.7831401 C43.2975951,45.8892797 45.5539053,43.92813 47.6748637,43.7994909 L47.8937305,43.7927983 L53.5651311,43.7927983 Z M29.2555813,26.2894258 C33.8666982,25.8697819 38.4082882,27.4813138 41.7157775,30.7093439 L41.7157775,30.7093439 L42.050996,31.0346301 L40.1911541,32.894472 L39.865868,32.5766352 C37.3951834,30.1754774 34.1472885,28.8544682 30.7206104,28.8544682 C26.988511,28.8544682 23.4178131,30.4560677 20.9222975,33.2470722 C18.3945016,36.0753232 17.2348939,39.7205141 17.6619871,43.514691 C17.982307,46.3528744 19.2710359,49.0619366 21.2947625,51.1477407 L21.2947625,51.1477407 L21.6101162,51.4730268 L19.7502742,53.3328688 L19.4249881,52.9976502 C16.1125326,49.5982862 14.5158993,44.9325412 15.0447996,40.1972693 C15.8691888,32.8125297 21.8460107,26.9623459 29.2555813,26.2894258 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaSignetDarkBackground);
export default __webpack_public_path__ + "static/media/CA-Signet-Dark-Background.c45af4bad448556e5eb175ff97e9c886.svg";
export { ForwardRef as ReactComponent };